import { render, staticRenderFns } from "./my-common-dialog.vue?vue&type=template&id=5ffa734e&scoped=true&"
import script from "./my-common-dialog.vue?vue&type=script&lang=ts&"
export * from "./my-common-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./my-common-dialog.vue?vue&type=style&index=0&id=5ffa734e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffa734e",
  null
  
)

export default component.exports